import { render, staticRenderFns } from "./ArticleHtml.vue?vue&type=template&id=4a5a70d9&"
import script from "./ArticleHtml.vue?vue&type=script&lang=js&"
export * from "./ArticleHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports